Jelly.Interface.Show_Lightbox = function(Parameters)
{
	// Generate lightbox if it doesn't exist, then move it to beneath top window, and display it. 
	 
	// Generate lightbox, if it doesn't exist.
	if (!Jelly.Interface.Lightbox_Element)
	{
		Jelly.Interface.Lightbox_Element = Jelly.Interface.Generate_Lightbox();
		Jelly.Interface.Global_Controls_Element.appendChild(Jelly.Interface.Lightbox_Element);
	}

	if (Parameters && Parameters["Container"] && Parameters["Container"].toLowerCase() == "interstitial") {
		$(Jelly.Interface.Lightbox_Element).removeClass("Quick_Window").addClass("Interstitial");	
	}
	else if (Parameters && Parameters["Container"] && Parameters["Container"].toLowerCase() == "quick_window") {
		$(Jelly.Interface.Lightbox_Element).removeClass("Interstitial").addClass("Quick_Window");	
	}
	else { 
		$(Jelly.Interface.Lightbox_Element).removeClass("Interstitial Quick_Window");
	}

	// Move lightbox beneath highest window.
	// TODO: Strange Z-Index metric. I guess it makes sense, but I'm leaving this here in case we decide to switch to -1, 0 instead of 0, +1 as it is now.
	Jelly.Interface.Lightbox_Element.style.zIndex = Jelly.Interface.Window_Z_Index_Start + Jelly.Interface.Modal_Windows.length * 2;

	// Add Overlay class
	if (Parameters && Parameters. Overlay) { 
		$(Jelly.Interface.Lightbox_Element).addClass('Overlay');
	}
	
	// Fade in lightbox
	// Only fade in if the lightbox is currently hidden
	if (Jelly.jQuery(Jelly.Interface.Lightbox_Element).is(':hidden')) {
		Jelly.Interface.Lightbox_Element.style.display = "none";
		Jelly.jQuery(Jelly.Interface.Lightbox_Element).fadeIn("fast");
	}
};